import { useTheme } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import { DateTime } from "luxon";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/airbnb.css";
import CalendarHours from "./calendarHours";
import CcButton from "../../ccButton";

const CalendarPage = ({ data, dayDate, setDayDate, selectedTime, setSelectedTime, setPage, summaryStyle}) => {
  const today = new Date(dayDate);
  const theme = useTheme();
  const formRef = useRef(null);
  const { availability, setSeparately } = data.availability;
  const [selectedDay, setSelectedDay] = useState(today.getDay());

  const flatpickrOverride = {
    ".flatpickr-calendar": {
      boxShadow: "none",
    },
    ".flatpickr-monthDropdown-months": {
      webkitAppearance: "initial",
      appearance: "initial",
    },
    ".flatpickr-day": {
      border: "0 !important",
      "&.today": {
        borderBottom: `1px solid ${theme.colors.error} !important`,
      },
      "&.selected": {
        background: `${theme.colors.primary} !important`,
        borderColor: `${theme.colors.primary} !important`,
      },
    },
  };

  const fieldsetStyle = {
    border: 0,
    margin: 0,
    height: 330,
    overflowY: "auto",
    padding: "0 10px",
    "&:not(:last-of-type)": {
      marginRight: 10,
    },
    ...flatpickrOverride,
  };

  const rowStyle = {
    display: "flex",
    margin: "0 -10px",
  };

  useEffect(() => {
    if (!availability.length) return;
    const calendarInput = formRef?.current?.querySelector(".flatpickr-input");
    if (calendarInput) calendarInput.setAttribute("type", "hidden");
  }, [availability]);

  const checkIfAvailable = (day) => {
    const isDisabled = availability.find((dayData) => +dayData.dayIndex === +day)?.disabled;
    return typeof(isDisabled) === "boolean" ? isDisabled : true;
  };

  const hoursRangeForDay = () => availability.find((day) => day.dayIndex === selectedDay);

  return (
    <>
      {availability.length > 0 && (
        <div css={rowStyle} ref={formRef}>
          <fieldset css={fieldsetStyle}>
            <Flatpickr 
              options={{
                inline: true,
                minDate: "today",
                locale: {
                  firstDayOfWeek: 1,
                },
                defaultDate: dayDate,
                disable: [(date) => checkIfAvailable(date.getDay())],
                onChange: (selectedDates) => {
                  setDayDate(new Date(selectedDates[0]));
                  setSelectedDay(new Date(selectedDates[0]).getDay());
                },
              }}
            />
          </fieldset>
          <fieldset css={fieldsetStyle}>
            <CalendarHours
              day={hoursRangeForDay()}
              date={dayDate}
              selectedTime={selectedTime}
              setTime={setSelectedTime}
              setSeparately={setSeparately}
              global={availability[0]}
            />
          </fieldset>
        </div>
      )}
      <div css={summaryStyle}>
        <span>{DateTime.fromISO(new Date(dayDate).toISOString()).toLocaleString(DateTime.DATE_FULL)} {selectedTime}</span>
        {selectedTime && (
          <CcButton
            onClick={() => setPage(1)}
            label="Confirm date"
            fullWidth={false}
            isActive={true}
          />
        )}
      </div>
    </>
  );
};

export default CalendarPage;
